import * as React from 'react'
import { createContainer } from 'unstated-next'

import { ViewportSizes, useIsViewport } from '@syconium/little-miss-figgy'

export type UseFilterModalServiceOpts = {
  initialShouldDisplayFilterModal?: boolean
  initialShouldRenderFilterModal?: boolean
}

function useFilterModalService({
  initialShouldDisplayFilterModal = false,
  initialShouldRenderFilterModal = false,
}: UseFilterModalServiceOpts = {}) {
  const isSmallViewport = useIsViewport(ViewportSizes.small)

  const [shouldDisplayFilterModal, setShouldDisplayFilterModal] = React.useState<boolean>(
    initialShouldDisplayFilterModal
  )
  const [shouldRenderFilterModal, setShouldRenderFilterModal] = React.useState<boolean>(
    initialShouldRenderFilterModal
  )

  function openFilterModal(): void {
    setShouldDisplayFilterModal(true)
  }

  function closeFilterModal(): void {
    setShouldDisplayFilterModal(false)
  }

  React.useEffect(() => {
    if (isSmallViewport) {
      setShouldRenderFilterModal(true)
    }
  }, [isSmallViewport])

  return {
    closeFilterModal,
    openFilterModal,
    shouldDisplayFilterModal,
    shouldRenderFilterModal,
  }
}

export const FilterModalService = createContainer(useFilterModalService)
